import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, formatApiError } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Heart } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Bottone "cuore" per salvare/rimuovere una partita dai preferiti.
 * Auto-fetch dello stato iniziale se logged in.
 */
export default function BatchFavoriteButton({ batchId, size = 14, className = '', stopPropagation = true }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user || !batchId) return;
    api.get('/batches/favorites/mine')
      .then(r => setSaved(!!(r.data || []).find(b => b.batch_id === batchId)))
      .catch(()=>{});
  }, [user, batchId]);

  const toggle = async (e) => {
    if (stopPropagation) { e?.preventDefault?.(); e?.stopPropagation?.(); }
    if (!user) { nav('/login'); return; }
    if (busy) return;
    setBusy(true);
    try {
      if (saved) {
        await api.delete(`/batches/${batchId}/favorite`);
        setSaved(false); toast('Rimossa dai preferiti');
      } else {
        await api.post(`/batches/${batchId}/favorite`);
        setSaved(true); toast.success('Salvata nei preferiti');
      }
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid={`batch-fav-${batchId}`}
      aria-label={saved ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'}
      className={`grid place-items-center rounded-full bg-background/90 backdrop-blur border border-border w-8 h-8 hover:bg-background transition ${className}`}
    >
      <Heart size={size} strokeWidth={1.7} className={saved ? 'fill-terracotta text-terracotta' : 'text-foreground'}/>
    </button>
  );
}
